/** Modos de entrega no checkout da loja pública. */
export const CHECKOUT_FULFILL_PICKUP = 'pickup';
export const CHECKOUT_FULFILL_NEW = 'new';

export function checkoutFulfillmentSavedValue(addressId) {
  const id = Number(addressId);
  if (!Number.isFinite(id) || id < 1) return '';
  return `saved:${id}`;
}

export function checkoutFulfillmentParseSavedId(mode) {
  if (typeof mode !== 'string' || !mode.startsWith('saved:')) return null;
  const id = Number(mode.slice(6));
  return Number.isFinite(id) && id > 0 ? id : null;
}

/** @param {boolean} pickupOnly @param {Array<{id?:number|string,is_default?:number|boolean}>} addresses */
export function checkoutFulfillmentDefaultMode(pickupOnly, addresses = []) {
  if (pickupOnly) return CHECKOUT_FULFILL_PICKUP;
  const list = Array.isArray(addresses) ? addresses : [];
  if (list.length > 0) {
    const def = list.find((a) => Number(a?.is_default) === 1);
    const pick = def || list[0];
    if (pick?.id != null) return checkoutFulfillmentSavedValue(pick.id);
  }
  return CHECKOUT_FULFILL_PICKUP;
}

export function checkoutFulfillmentIsPickup(mode) {
  return mode === CHECKOUT_FULFILL_PICKUP;
}

export function checkoutFulfillmentIsNewAddress(mode) {
  return mode === CHECKOUT_FULFILL_NEW;
}

export function checkoutFulfillmentIsSaved(mode) {
  return checkoutFulfillmentParseSavedId(mode) != null;
}
